import {createTheme} from "@mui/material";

const theme = createTheme({
    palette: {
        primary: {
            main: '#2697BD',
        },
        secondary: {
            main: '#F46534',
        },
    },
    typography: {
        fontFamily: ['Open Sans', 'Roboto', 'Helvetica Neue'].join(','),
        h1: {
            fontWeight: 700,
            fontSize: '1.5rem',
            color: '#2E3A49 !important',
        },
        h2: {
            fontWeight: 700,
            fontSize: '1.25rem',
            color: '#2E3A49',
        },
        h3: {
            fontWeight: 700,
            fontSize: '1rem',
            color: '#2E3A49',
            textTransform: 'uppercase',
        },
        h4: {
            fontWeight: 700,
            fontSize: '1rem',
            color: '#2697BD',
        },
        body1: {
            fontWeight: 400,
            fontFamily: '1rem',
            color: '#586679',
        }
    },
    components: {
        MuiInput: {
            styleOverrides: {
                root: {
                    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button':
                        {
                            display: 'none',
                        },
                    '& input[type=number]': {
                        MozAppearance: 'textfield',
                    },
                },
            },
        },
        MuiRadio: {
            styleOverrides: {
                root: {
                    color: 'black',
                    accentColor: 'white'
                }
            }

        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    fontFamily: ['Open Sans', 'Roboto', 'Helvetica Neue'].join(','),
                },
                head: {
                    fontSize: '0.875rem',
                    fontWeight: 700,
                    color: '#FFFFFF'
                },
                body: {
                    fontSize: '1rem',
                    fontWeight: 400,
                    color: '#586679'
                },
            }
        },
        MuiTabs: {
            styleOverrides: {
                indicator: {
                    bottom: 'inherit',
                    backgroundColor: '#F46534'
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    fontFamily: ['Open Sans', 'Roboto', 'Helvetica Neue'].join(','),
                    minHeight: '30px',
                    fontWeight: 700,
                    fontSize: '1rem',
                    textTransform: 'uppercase',
                    color: '#7A838E',
                    "&.Mui-selected": {
                        "color": "#2E3A49",
                    }
                },
            }
        }
    },
    spacing: (factor: any) => `${0.25 * factor}rem`, // (Bootstrap strategy)
});

export type LocalTheme = typeof theme;

export default theme;

declare module '@emotion/react' {
    export interface Theme extends LocalTheme {
    }
}